<template>
	<MinimalLayout>
		<WizardContainer :phase="props.phase" :step="props.step" />
	</MinimalLayout>
</template>

<script setup lang="ts">
import MinimalLayout from '@/components/layout/MinimalLayout.vue';
import WizardContainer from '@/components/WizardContainer.vue';

interface Props {
	phase?: number;
	step?: string;
}

const props = withDefaults(defineProps<Props>(), {
	phase: 1,
	step: '1',
});
</script>
